import { parse } from 'date-fns'
import { getExchangeNow, isTradingDayDate } from '@/lib/exchange-time'

const START_YEAR = 2010
const START_MONTH = 0

/**
 * Months from Jan 2010 → current month in EXCHANGE time. Call per popover
 * open (not module-level) so the list extends across rollovers in long-lived
 * tabs.
 */
export function buildAllMonths(): Date[] {
  const now = getExchangeNow()
  const endYear = now.getFullYear()
  const endMonth = now.getMonth()
  const months: Date[] = []
  for (let y = START_YEAR; y <= endYear; y++) {
    const lastMonth = y === endYear ? endMonth : 11
    for (let m = y === START_YEAR ? START_MONTH : 0; m <= lastMonth; m++) {
      months.push(new Date(y, m, 1))
    }
  }
  return months
}

/**
 * Parse YYYY-MM-DD → Date at LOCAL midnight (matches react-day-picker's day
 * cells so direct comparisons work). Reference anchored to exchange time.
 */
export function parseDateStr(s: unknown): Date | undefined {
  if (typeof s !== 'string') return undefined
  try {
    const d = parse(s, 'yyyy-MM-dd', getExchangeNow())
    return isNaN(d.getTime()) ? undefined : d
  } catch {
    return undefined
  }
}

export function parseUserDate(text: string): Date | undefined {
  const formats = ['M/d/yyyy', 'MM/dd/yyyy', 'yyyy-MM-dd']
  for (const fmt of formats) {
    try {
      const d = parse(text.trim(), fmt, getExchangeNow())
      if (!isNaN(d.getTime())) return d
    } catch {
      // try next
    }
  }
  return undefined
}

export function findMonthIndex(months: Date[], date: Date): number {
  const idx = months.findIndex(
    (m) => m.getFullYear() === date.getFullYear() && m.getMonth() === date.getMonth(),
  )
  return idx >= 0 ? idx : months.length - 1
}

/**
 * Day cell disabled iff it's after `todayDate` (exchange-today, LOCAL-midnight)
 * or a non-trading day (weekend / US market holiday).
 */
export function isDateDisabled(date: Date, todayDate: Date): boolean {
  if (date > todayDate) return true
  return !isTradingDayDate(date)
}
